var exports = {
  "container": "x61f99309--48214d--container",
};

module.exports = exports;
